<template>
	<div>
		<Loading title="Szobák betöltése" v-if="!rooms"></Loading>
		<div v-else>
			<p>A választott időpontban a következő {{selected_guesthouse.apartment ? 'apartmanok' : 'szobák'}} szabadok: <help class="float-end" helpId="step2_help" title="Szobák kiválasztása" text="jelölje be a kivenni kívánt szobákat"></help></p>
			<form @submit.prevent="validate">
				<div class="table-responsive" v-if="rooms.length > 0">
					<table class="table table-bordered align-middle">
						<thead>
							<tr>
								<th>Lefoglal</th>
								<th>Megnevezés</th>
								<th>Leírás</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(room,id) in rooms" :key="id">
								<td>
									<div class="form-check form-switch">
										<input class="form-check-input" type="checkbox" :true-value="true" :false-value="false" v-model="room.rent" @change="roomCheckboxHandle(room)"/>
									</div>
								</td>
								<td>{{room.name}} ({{room.capacity}}) ágyas</td>
								<td v-html="room.description"></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="text-center" v-else>
					<h1><i class="fa fa-calendar-times fa-2x mb-2"></i></h1>
					<h3 class="mb-2">A választott időszakban egy szoba sem szabad!</h3>
					<small>Módosítsa az időpontot vagy válasszon másik vendégházat!</small>
				</div>
				<button class="d-none" type="submit" ref="submitter"></button>
			</form>
		</div>
	</div>
</template>

<script>
import Confirmation from "../../apis/Confirmation";
import Booking from "../../apis/Booking";
export default {
  data(){
		return {
			rooms:null,
      model: {
        rooms: [],
      },
			message:false,
	}},
	computed:{
		selected_guesthouse(){
			return this.$store.state.selected_guesthouse ?? null;
		},
		arrive_at(){
			return this.$store.state.arrive_at;
		},
		leave_at(){
			return this.$store.state.leave_at;
		},
		getrooms_object(){
			return {
				guest_house_id: this.selected_guesthouse.id,
				arrive_at: this.arrive_at,
				leave_at: this.leave_at,
			}
		},
		rooms_to_emit(){
			return this.model.rooms.map(r => ({
				id: r.id,
				name:r.name,
				users: Array(r.capacity).fill({
					name:null,
					guest_category_id:null,
					date_of_birth:null,
				})
			}));
		}
	},
	watch:{
		selected_guesthouse(val,oldVal){
			if(val && val.id && val != oldVal){
				this.model.rooms = [];
				this.getRooms();
			}
		},
		arrive_at(val,oldVal){
			if(val && val != oldVal){
				this.model.rooms = [];
				this.getRooms();
			}
		},
		leave_at(val,oldVal){
			if(val && val != oldVal){
				this.model.rooms = [];
				this.getRooms();
			}
		},
	},
  methods: {
		roomCheckboxHandle(room){
			if(room.rent){
				this.model.rooms.push(JSON.parse(JSON.stringify(room)));
			}else{
				this.model.rooms.splice(this.model.rooms.findIndex(r => r.id == room.id),1);
			}
		},
		getRooms(){
			//console.log('lefut a getrooms')
			Booking.getRooms(this.getrooms_object)
			.then(response => {
				this.rooms = response.data;
				this.message = false;
				this.model.rooms.forEach((r,i) => {
					if(!this.rooms.map(v => v.id).includes(r.id)){
						this.model.rooms.splice(i,1);
						this.message = true;
					}
				});
				this.rooms.forEach(r => {
					if(this.model.rooms.map(v => v.id).includes(r.id)){
						r.rent = true;
					}
				})
			})
		},
    validate() {
			if(this.model.rooms.length == 0){
				Confirmation.swalErrorMessage('Válassz minimum 1 szobát!');
			}else{
				this.$emit('validated',null);
				this.$store.commit('updateSelectedRooms',this.rooms_to_emit);
			}
    },
		submitForm(){
			this.$refs.submitter.click();
		}
  }

}
</script>
